export default {
  fontFamily: "th-font-family",
  classLang: "th",
  headlist: [
    // {
    //   text: "หน้าหลัก",
    //   url: "/",
    // },
    {
      text: "การซื้อขาย",
      menu: [
        {
          tit: "ผลิตภัณฑ์เทรด",
          list: [
            {
              text: "ฟอเร็กซ์",
              url: "/tradingproduct?index=0",
            },
            {
              text: "สินค้าโภคภัณฑ์",
              url: "/tradingproduct?index=1",
            },
            {
              text: "ดัชนี",
              url: "/tradingproduct?index=2",
            },
            {
              text: "หุ้นสหรัฐฯ",
              url: "/tradingproduct?index=3",
            },
            {
              text: "ETF",
              url: "/tradingproduct?index=4",
            },
          ],
        },
        {
          tit: "บัญชีและเงื่อนไข",
          list: [
            {
              text: "บัญชีธุรกรรม",
              url: "/TradingAccount",
            },
            // {
            //   text: "ซื้อขายสินค้า",
            //   url: "/tradingproduct",
            // },
            {
              text: "เลเวอเรจมาร์จิ้น",
              url: "/leverage-margin",
            },
            {
              text: "ฝากและถอนเงิน",
              url: "/funding",
            },
            {
              text: "เงินปันผล",
              url: "/dividend",
            },
            {
              text: "บริการสถาบัน",
              url: "/service",
            },
            {
              text: "เชื่อมต่อสภาพคล่อง",
              url: "/technology",
            },
          ],
        },
        {
          tit: "เครื่องมือการซื้อขาย",
          list: [
            {
              text: "ดาวน์โหลด MT4",
              url: "/MT4",
            },
            {
              text: "ดาวน์โหลด MT5",
              url: "/MT5",
            },
            {
              text: "EA Forex & Indicator",
              url: "/tools",
            },
            {
              text: "PAMM",
              url: "/PAMM",
            },
            {
              text: "การวิเคราะห์ตลาด",
              url: "/market-analysis",
            },
          ],
        },
      ],
    },
    {
      text: "EBCสถาบัน",
      menu: [
        {
          tit: "",
          list: [
            {
              text: "ศูนย์การเรียนรู้",
              url: "/LearningCenter",
            },
            {
              text: "ศูนย์ข้อมูล",
              url: "/lab",
            },
          ],
        },
      ],
    },
    
    {
      text: "เกี่ยวกับ EBC",
      menu: [
        {
          tit: "เกี่ยวกับ EBC",
          list: [
            {
              text: "เกี่ยวกับ EBC",
              url: "/about-us",
            },
            {
              text: "ทำไมต้อง EBC",
              url: "/ESG",
            },
             {
              text: "ข่าวสาร EBC",
              url: "/LearningCenter?tabId=1",
            },
            {
              text: "คำถามที่พบบ่อย",
              url: "https://support.ebchelp.com/hc/en-001",
            },
            {
              text: "ตรวจสอบเว็บไซต์",
              url: "/official-verification",
            },
          ],
        },
        {
          tit: "โหมดความร่วมมือ",
          list: [
            {
              text: "สโมสรบาร์เซโลนา",
              url: "/FCB",
            },
            {
              text: "มหาวิทยาลัย Oxford",
              url: "/partners/oxford",
            },
            {
              text: "อิทธิพลที่มีต่อพันธมิตร",
              url: "/affiliate-programmes",
            },
            // {
            //   text: "บริการสถาบัน",
            //   url: "/service",
            // },
            // {
            //   text: "เทคโนโลยีพื้นฐาน",
            //   url: "/technology",
            // },
          ],
        },
      ],
    },
    {
      text: "กิจกรรม",
      url: "",
      menu: [
        {
          tit: "EBC人気キャンペーン",
          list: [
            {
              text: "EBC 백만 달러 실거래 대회 Ⅱ",
              url: "/million-dollar-challenge-2",
            },
            
            {
              text: "펀드매니저 프로그램",
              url: "/pay",
            },{
              text: "전체 보기",
              url: "/activity",
            },
           
          ],
        },
      ],
    },
  ],
  FCA开户: "บัญชี FCA",
  立即开户: "เปิดบัญชีฟรี",
  登录: "เข้าสู่ระบบ",
  官方验证: "ตรวจสอบเว็บไซต์",
  帮助中心: "คำถามที่พบบ่อย",
  帮助中心Url: "https://support.ebchelp.com/hc/en-001",
};
